// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hcgau","colMin":"styles_colMin__zEXtl"};